import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/groupIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/amelie-snowdon.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/anders-blomqvist.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/anders-jarlskog.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/cajsa-johansson.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/charlotta-nilsson.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/christian-olsen.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/filip-ternemo.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/filip-vitalisson.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/kristian-schmidt.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/linus-oscarsson.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/nina-hansson.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/philip-grange.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/pia-bjorkman.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/pierre-jarlskog.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/pontus-jakobinsson.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/teamMain.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/teamMainImageMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/zoran-mitrovic.png");
